import React from 'react';
import PropTypes from 'prop-types';
import { trackDownload } from 'utils/general';

// components
import VideoContent from 'components/common/modals/VideoContent';
import ImageContent from 'components/common/modals/ImageContent';

class Thumbnail extends React.Component {
  constructor(props) {
    super(props);

    // Bindings
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { data, type } = this.props;

    if (type) {
      const content = type === 'video' ?
        <VideoContent title={data.title} src={data.src} /> :
        <ImageContent title={data.title} src={config.apiHost + data.src} />;
      this.props.setModalContent(content);
    }
  }

  render() {
    const { data, options, className = '' } = this.props;

    return (
      <div className={`c-thumbnail ${className}`}>
        <div className="thumbnail" style={{ backgroundImage: `url(${config.apiHost + data.thumbnail})` }}>
          <div className="hover-viel" onClick={this.onClick}>
            {options.isDownload ?
              <a href={config.apiHost + data.src} target="_blank" className="download" onClick={trackDownload}>
                {data.hoverData}
              </a> :
              data.hoverData
            }
          </div>
        </div>
        {options.showTitle &&
          <div className="info">
            <h2 className="title">{data.title}</h2>
            {data.date && <h3 className="date">{data.date}</h3>}
            {data.description && <p className="description">{data.description}</p>}
          </div>
        }
      </div>
    );
  }
}

Thumbnail.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
  // Actions
  setModalContent: PropTypes.func
};

Thumbnail.defaultProps = {
  data: {},
  options: {
    showTitle: true,
    isDownload: false
  },
  className: ''
};

export default Thumbnail;



// WEBPACK FOOTER //
// ./app/components/media-publications/Thumbnail.jsx